import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of, Subject, BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';
import {RewardModel} from '../models/data.model';
import {UnclipRewardModel} from '../models/data.model';
import {UnclipRewardDetailModel} from '../models/data.model';
import {RewardsSummaryService} from '../services/rewards-summary.service';
import {AuthService} from '../services/auth.service';
import {environment} from '../../../environments/environment';
import {RewardService} from '../services/reward.service';
import {v4 as uuidv4} from 'uuid';
import {ParamService} from '../services/param.service';
function _window(): any {
    return window;
}

@Injectable({
    providedIn: 'root',
})
export class PointsModalService {
    banner = '';
    public selectedRewardsOffers = new BehaviorSubject<any[]>([]);
    private userEndpoint = '/bin/safeway/userinfo?banner=tomthumb';

    public constructor(private _http: HttpClient, private _rewardsSummaryService: RewardsSummaryService, private _authService: AuthService, private rewardService: RewardService,private paramService: ParamService) {
        this.banner = this.paramService.banner
    }

    public getSelectedRewardsOffers(userInfo, currentEnvironment): Observable<RewardModel[]> {

        if (this._authService.isTokenValidForSession(userInfo)) {
            let httpOptions: any;
            const headerObj = environment[currentEnvironment].rewardsLookupConfig.j4uHttpOptions30Header;
            this.rewardService.replaceHeaderBanner(headerObj);
            httpOptions = {
                headers: {
                    ...headerObj,
                    'X-swyConsumerDirectoryPro': userInfo.SWY_SHOP_TOKEN,
                    'SWY_SSO_TOKEN': userInfo.SWY_SHOP_TOKEN,
                    'x-swy-correlation-id': uuidv4()
                }
            };
            let storeId;
            storeId = this.rewardService.getStoreIdForUserType(userInfo);
            const dataUrl = this.rewardService.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.selectedRewardspath + '?storeId=' + storeId;
            return this._http
                .get(dataUrl, httpOptions)
                .pipe(map((response: any) => {
                    response.myGroceryRewardsList.forEach(reward => {
                        reward['endDate'] = reward['endDate'].split('(')[1].split(')')[0];
                        reward['buttonText'] = 'Unclip';
                    });
                    return response.myGroceryRewardsList;
                }));
        } else {
            return of();
        }

    }

    public getSelectedRewardsOffersMultiClip(userInfo, currentEnvironment): Observable<RewardModel[]> {
        if (this._authService.isTokenValidForSession(userInfo)) {
            let httpOptions: any;
            const headerObj = environment[currentEnvironment].rewardsLookupConfig.j4uHttpOptions30Header;
            this.rewardService.replaceHeaderBanner(headerObj);
            httpOptions = {
                headers: {
                    ...headerObj,
                    'X-swyConsumerDirectoryPro': userInfo.SWY_SHOP_TOKEN,
                    'SWY_SSO_TOKEN': userInfo.SWY_SHOP_TOKEN,
                    'x-swy-correlation-id': uuidv4()
                }
            };
            let storeId;
            storeId = this.rewardService.getStoreIdForUserType(userInfo);
            const dataUrl = this.rewardService.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.selectedRewardspath + '?storeId=' + storeId;
            return this._http
                .get(dataUrl, httpOptions)
                .pipe(map((response: any) => {
                    response.myGroceryRewardsList.forEach(reward => {
                        reward['endDate'] = reward['endDate'].split('(')[1].split(')')[0];
                        reward['buttonText'] = 'Unclip';
                    });
                    return response.myGroceryRewardsList;
                }));
        } else {
            return of();
        }
    }

    public getSelectedRewardsTotal(userInfo, currentEnvironment): Observable<number> {
        if (this._authService.isTokenValidForSession(userInfo)) {
            let httpOptions: any;
            const headerObj = environment[currentEnvironment].rewardsLookupConfig.j4uHttpOptions30Header;
            this.rewardService.replaceHeaderBanner(headerObj);
            httpOptions = {
                headers: {
                    ...headerObj,
                    'X-swyConsumerDirectoryPro': userInfo.SWY_SHOP_TOKEN,
                    'SWY_SSO_TOKEN': userInfo.SWY_SHOP_TOKEN,
                    'x-swy-correlation-id': uuidv4()
                }
            };
            let storeId;
            storeId = this.rewardService.getStoreIdForUserType(userInfo);
            const dataUrl = this.rewardService.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.selectedRewardspath + '?storeId=' + storeId;

            return this._http
                .get(dataUrl, httpOptions)
                .pipe(map((response: any) => {
                    let count = 0;
                    response.myGroceryRewardsList.forEach(reward => {
                        count += reward['rewardsRequired'];
                    });
                    return count;
                }));
        } else {
            return of(0);
        }

    }

    public getSelectedRewardsTotalMulticlip(userInfo, currentEnvironment): Observable<number> {
        if (this._authService.isTokenValidForSession(userInfo)) {
            let httpOptions: any;
            const headerObj = environment[currentEnvironment].rewardsLookupConfig.j4uHttpOptions30Header;
            this.rewardService.replaceHeaderBanner(headerObj);
            httpOptions = {
                headers: {
                    ...headerObj,
                    'X-swyConsumerDirectoryPro': userInfo.SWY_SHOP_TOKEN,
                    'SWY_SSO_TOKEN': userInfo.SWY_SHOP_TOKEN,
                    'x-swy-correlation-id': uuidv4()
                }
            };
            let storeId;
            storeId = this.rewardService.getStoreIdForUserType(userInfo);
            const dataUrl = this.rewardService.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.selectedRewardspath + '?storeId=' + storeId;

            return this._http
                .get(dataUrl, httpOptions)
                .pipe(map((response: any) => {
                    let count = 0;
                    response.myGroceryRewardsList.forEach(reward => {
                        if (reward['usageType'] === 'O' || reward['usageType'] === 'U') {
                            count += reward['rewardsRequired'];
                        } else {
                            count += (reward['rewardsRequired'] * reward['clipDetails'].clippedCount);
                        }

                    });
                    return count;
                }));
        } else {
            return of(0);
        }
    }

    public callUnclipAPI(reward: RewardModel, userInfo): Observable<UnclipRewardModel[]> {
        if (this._authService.isTokenValidForSession(userInfo)) {
            const httpOptions = {headers: new HttpHeaders(window['AB'].rewardUnclipHttpOptions)};
            let unclipURL = window['AB']['rewardUnclipPath'];
            unclipURL = unclipURL.replace('{storeId}', _window().AB.storeInfo.storeId);
            const reqBody = {
                items: [
                    {
                        clipId: reward.clipId,
                    },
                ],
            };
            return this._http.post(unclipURL, reqBody, httpOptions)
                .pipe(map((response: any) => {
                    this._updateLocalStorageRewardsInfo(reward, false);
                    this._rewardsSummaryService.$initPointScorecard.next(response.items[0]);
                    return response.items;
                }));
        } else {
            return of();
        }
    }

    public callUnclipMulticlipAPI(reward: RewardModel, userInfo, currentEnvironment): Observable<UnclipRewardModel[]> {
        if (this._authService.isTokenValidForSession(userInfo)) {
            // const httpOptions = {headers: new HttpHeaders(window['AB'].rewardUnclipHttpOptions)};
            // let unclipURL = window['AB']['rewardUnclipPath'];
            // unclipURL = unclipURL.replace('{storeId}', _window().AB.storeInfo.storeId);
            let httpOptions: any;
            const headerObj = environment[currentEnvironment].rewardsLookupConfig.rewardUnclipHttpOptions;
            this.replaceHeaderBanner(headerObj);
            httpOptions = {
                headers: {
                    ...headerObj,
                    'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                    'x-swy-correlation-id': uuidv4()
                }
            };

        let unclipURL = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.rewardUnclipPath;
            let storeId;
            storeId = this.rewardService.getStoreIdForUserType(userInfo);
        unclipURL = unclipURL.replace('{storeId}', storeId);
            const reqBody = {
                items: [
                    {
                        clipId: reward.clipDetails.clipped[0],
                    },
                ],
            };
            return this._http.post(unclipURL, reqBody, httpOptions)
                .pipe(map((response: any) => {
                    this._updateLocalStorageRewardsInfo(reward, false);
                    this._rewardsSummaryService.$initPointScorecard.next(response.items[0]);
                    return response.items;
                }));
        } else {
            return of();
        }
    }

    public replaceHeaderBanner(header) {
        if (header) {
            if (header['banner']) {
                header['banner'] = header['banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy_banner']) {
                header['x-swy_banner'] = header['x-swy_banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['X-SWY_BANNER']) {
                header['X-SWY_BANNER'] = header['X-SWY_BANNER'].replace(/\{banner\}/g, this.banner);
            }
            if (header['SWY_BANNER']) {
                header['SWY_BANNER'] = header['SWY_BANNER'].replace(/\{banner\}/g, this.banner);
            }
            if (header['X-Swy_banner']) {
                header['X-Swy_banner'] = header['X-Swy_banner'].replace(/\{banner\}/g, this.banner);
            }


        }
    }

    parseJwt(jwtToken) {
        const base64Url = jwtToken.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }

    getUserClaims(user) {
        const oktaToken = this.parseJwt(user.SWY_SHOP_TOKEN);
        const userClaims = {
            aln: oktaToken['aln'],
            hid: oktaToken['hid'],
            zip: oktaToken['zip'],
            gid: oktaToken['gid'],
            uuid: oktaToken['uuid'],
            exp: oktaToken['exp'],
            firstname: oktaToken['fnm'],
            lastname: oktaToken['lnm']
        };
        return userClaims;
    }

    getApplicationDomainURL() {
        let domain;
        if (this.getLocationHref().indexOf('local') > 0) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + this.getLocationHost();
        }
        return domain;
    }

    getLocationHref() {
        return window.location.href;
    }

    getLocationHost() {
        return window.location.host;
    }

    public newCheckUnclipDetail(reward: RewardModel, userInfo, currentEnvironment) {
        if (this._authService.isTokenValidForSession(userInfo)) {
            let clipId = reward.usageType == "M" ? reward.clipDetails.clipped[0] : reward.clipId;
            const headerObj = environment[currentEnvironment].rewardsLookupConfig.xAPIOcrpRewardsHttpOptionsV2;
            this.replaceHeaderBanner(headerObj);
            let httpOptions: any;
            httpOptions = {
                headers: {
                    ...headerObj,
                    'x-swy-correlation-id': uuidv4(),
                    Authorization: "Bearer " + userInfo.SWY_SHOP_TOKEN,
                }
            };
            const userClaims = this.getUserClaims(userInfo);
            const checkUnclipDetailUrl = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.checkUnclipDetail + '/' + userClaims.hid + '/' + clipId;
            return this._http.get(checkUnclipDetailUrl, httpOptions)
                .pipe(map((response) => {
                    let unclipRewardDetail: UnclipRewardDetailModel = new UnclipRewardDetailModel;
                    if (response) {
                        unclipRewardDetail['clipId'] = response['clipId'];
                        unclipRewardDetail['hhid'] = response['hhid'];
                        unclipRewardDetail['isPartiallyExpired'] = response['isPartiallyExpired'];
                        unclipRewardDetail['isValidForUnClip'] = response['isValidForUnClip'];
                        unclipRewardDetail['expiredPoints'] = response['expiredPoints'];
                        unclipRewardDetail['totalClippedPoints'] = response['totalClippedPoints'];
                    }
                    return unclipRewardDetail;
                }));
        }
    }

    public checkUnclipDetail(reward: RewardModel, userInfo, currentEnvironment) {
        if (this._authService.isTokenValidForSession(userInfo)) {
            const clipId = reward.usageType === 'M' ? reward.clipDetails.clipped[0] : reward.clipId;
            const headerObj = environment[currentEnvironment].rewardsLookupConfig.xAPIOcrpRewardsHttpOptions;
            this.replaceHeaderBanner(headerObj);
            let httpOptions: any;
            httpOptions = {
                headers: {
                    ...headerObj,
                    'x-swy-correlation-id': uuidv4(),
                    Authorization: "Bearer " + userInfo.SWY_SHOP_TOKEN,
                }
            };
            const userClaims = this.getUserClaims(userInfo);
            const checkUnclipDetailUrl = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.checkUnclipDetail + '/' + userClaims.hid + '/' + clipId;
            return this._http.get(checkUnclipDetailUrl, httpOptions)
                .pipe(map((response) => {
                    const unclipRewardDetail: UnclipRewardDetailModel = new UnclipRewardDetailModel;
                    if (response) {
                        unclipRewardDetail['clipId'] = response['clipId'];
                        unclipRewardDetail['hhid'] = response['hhid'];
                        unclipRewardDetail['isPartiallyExpired'] = response['isPartiallyExpired'];
                        unclipRewardDetail['isValidForUnClip'] = response['isValidForUnClip'];
                        unclipRewardDetail['expiredPoints'] = response['expiredPoints'];
                        unclipRewardDetail['totalClippedPoints'] = response['totalClippedPoints'];
                    }
                    return unclipRewardDetail;
                }));
        }
    }

    private _updateLocalStorageRewardsInfo(reward: RewardModel, isClip: boolean) {
        let rewardsAvailable = 0;
        let rewardExpire;
        const abRewardsSummaryLS = localStorage.abRewardsSummary;
        if (this._rewardsSummaryService.checkSummaryTime(abRewardsSummaryLS)) {
            const objRewardsPoints = JSON.parse(abRewardsSummaryLS);
            if (isClip) {
                rewardsAvailable = objRewardsPoints.rewardsAvailable - reward.rewardsRequired;
                rewardExpire = (objRewardsPoints.rewardsExpire > reward.rewardsRequired) ?
                    objRewardsPoints.rewardsExpire - reward.rewardsRequired : 0;

            } else {
                rewardsAvailable = objRewardsPoints.rewardsAvailable + reward.rewardsRequired;
                rewardExpire = (objRewardsPoints.rewardsExpire > reward.rewardsRequired) ?
                    objRewardsPoints.rewardsExpire : 0;

            }
            // If the rewardReq is greater then the expRewards
            // replace it with Zero.
            // else (expReward - rewardReq)
            const time = Date.now();
            const abRewardsSummary = {'rewardsAvailable': rewardsAvailable, 'rewardsExpire': rewardExpire, 'savedTime': time};
            localStorage.abRewardsSummary = JSON.stringify(abRewardsSummary);
        } else {
            if (isClip) {
                rewardsAvailable = reward.rewardsAvailable - reward.rewardsRequired;
                rewardExpire = (reward.rewardsExpire > reward.rewardsRequired) ? (reward.rewardsExpire - reward.rewardsRequired) : 0;

            } else {
                rewardsAvailable = reward.rewardsAvailable + reward.rewardsRequired;
                rewardExpire = (reward.rewardsExpire > reward.rewardsRequired) ? (reward.rewardsExpire) : 0;
            }
            const time = Date.now();
            const abRewardsSummary = {'rewardsAvailable': rewardsAvailable, 'rewardsExpire': rewardExpire, 'savedTime': time};
            localStorage.abRewardsSummary = JSON.stringify(abRewardsSummary);
        }
    }

    public dateConversion(dateServer: string): string {
        const dateStr = dateServer;
        const regex = /\d+/;
        const mills = regex.exec(dateStr);
        let result = '';
        if (Array.isArray(mills)) {
            const d = new Date(parseInt(mills[0], 10));
            d.setUTCMilliseconds(mills.index);
            result = d.toLocaleDateString('en-US');
        }

        return result;
    }
}
